import { Play, Linkedin, Quote } from 'lucide-react';

var VIDEO_PLACEHOLDERS = [
  { title: "Dealer Program Success Story", client: "Enterprise Client", videoUrl: null },
  { title: "Influencer Scan & Earn in Action", client: "Enterprise Client", videoUrl: null },
  { title: "WhatsApp Loyalty Journey", client: "Enterprise Client", videoUrl: null },
];

var PROGRAM_LAUNCHES = [
  { company: "Transasia", tagline: "Channel loyalty program launch", postUrl: null },
  { company: "Jio BP", tagline: "Partner engagement program launch", postUrl: null },
  { company: "UltraTech", tagline: "Wires & Cables loyalty program launch", postUrl: null },
  { company: "Jenburkt", tagline: "Physiotherapist engagement program launch", postUrl: null },
];

function VideoCard({ item, idx }) {
  return (
    <div className="rounded-2xl overflow-hidden border border-gray-200 bg-white shadow-sm hover:shadow-lg transition-shadow" data-testid={"testimonial-video-" + idx}>
      <div className="relative aspect-video bg-gradient-to-br from-[#2C39B8] to-[#1a2470] flex items-center justify-center">
        {item.videoUrl ? (
          <iframe src={item.videoUrl} title={item.title} className="absolute inset-0 w-full h-full" allowFullScreen />
        ) : (
          <div className="text-center">
            <div className="w-14 h-14 rounded-full bg-white/15 backdrop-blur flex items-center justify-center mx-auto mb-3">
              <Play size={24} className="text-white ml-1" />
            </div>
            <span className="text-white/70 text-xs font-medium uppercase tracking-wider">Video coming soon</span>
          </div>
        )}
      </div>
      <div className="p-4">
        <h4 className="font-semibold text-gray-900 text-sm">{item.title}</h4>
        <p className="text-xs text-gray-500 mt-1">{item.client}</p>
      </div>
    </div>
  );
}

function LaunchCard({ item, idx }) {
  var inner = (
    <>
      <div className="flex items-center gap-3 mb-3">
        <div className="w-9 h-9 rounded-lg bg-[#0A66C2]/10 flex items-center justify-center">
          <Linkedin size={18} className="text-[#0A66C2]" />
        </div>
        <span className="font-bold text-gray-900">{item.company}</span>
      </div>
      <p className="text-sm text-gray-600 mb-3">{item.tagline}</p>
      <span className="text-xs font-medium text-[#2C39B8]">
        {item.postUrl ? "View launch post →" : "Launch post coming soon"}
      </span>
    </>
  );
  var cls = "block p-5 rounded-2xl bg-white border border-gray-200 shadow-sm hover:shadow-lg hover:border-[#2C39B8]/30 transition-all";
  if (item.postUrl) {
    return <a href={item.postUrl} target="_blank" rel="noopener noreferrer" className={cls} data-testid={"launch-card-" + idx}>{inner}</a>;
  }
  return <div className={cls} data-testid={"launch-card-" + idx}>{inner}</div>;
}

export default function TestimonialsLaunches() {
  var videoCards = VIDEO_PLACEHOLDERS.map(function(v, i) { return <VideoCard key={i} item={v} idx={i} />; });
  var launchCards = PROGRAM_LAUNCHES.map(function(l, i) { return <LaunchCard key={i} item={l} idx={i} />; });

  return (
    <section className="py-20 bg-gray-50 halftone-overlay-dark" data-testid="testimonials-launches-section">
      <div className="container">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold tracking-wider uppercase border border-[#7CC326]/30 text-[#7CC326] bg-[#7CC326]/5 mb-4">
            <Quote size={12} /> Client Voices
          </span>
          <h2 className="text-gray-900 text-3xl md:text-4xl font-bold mb-3">Trusted by India&apos;s Leading Brands</h2>
          <p className="text-gray-500 max-w-2xl mx-auto">Real programs, real launches, real results from enterprise channel loyalty deployments.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
          {videoCards}
        </div>

        <div className="text-center mb-8">
          <h3 className="text-gray-900 text-xl md:text-2xl font-bold">Recent Program Launches</h3>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {launchCards}
        </div>
      </div>
    </section>
  );
}
